export enum MethodOfAcceptingTermsAndConditions {
	Monthly_Checkout = 'Monthly Checkout',
	My_Account = 'My Account',
}
